(() => {
  const BLOCK_SELECTOR = '[data-auto-add2cart-block]';
  const ITEM_SELECTOR = '[data-auto-add2cart-item]';
  const VARIANT_SELECTOR = '[data-auto-add2cart-variant-select]';
  let isAutoAdding = false;

  const DEBUG = (() => {
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.get('auto_add2cart_debug') === '1') return true;
      return window.localStorage.getItem('auto_add2cart_debug') === '1';
    } catch {
      return false;
    }
  })();

  function log(...args) {
    if (!DEBUG) return;
    console.log('[auto-add2cart]', ...args);
  }

  async function safeParseResponseJson(res) {
    const text = await res.text();
    const trimmed = text.trim();
    if (!trimmed || (trimmed[0] !== '{' && trimmed[0] !== '[')) return null;
    try {
      return JSON.parse(trimmed);
    } catch {
      return null;
    }
  }

  function getAutoAddItemsFromUI() {
    const block = document.querySelector(BLOCK_SELECTOR);
    if (!block) return [];

    const items = [];
    block.querySelectorAll(ITEM_SELECTOR).forEach((row) => {
      const select = row.querySelector(VARIANT_SELECTOR);
      if (!select || select.disabled) return;
      const id = parseInt(select.value, 10);
      if (!id) return;
      items.push({ id, quantity: 1 });
    });

    return items;
  }

  function bindFreePartVariantPickers() {
    const block = document.querySelector(BLOCK_SELECTOR);
    if (!block) return;

    block.querySelectorAll('select[data-auto-add2cart-variant-select]').forEach((select) => {
      select.addEventListener('change', () => {
        const row = select.closest(ITEM_SELECTOR);
        const imageEl = row?.querySelector('[data-auto-add2cart-image]');
        const option = select.selectedOptions[0];
        const imageUrl = option?.dataset?.image;
        if (imageEl && imageUrl) imageEl.src = imageUrl;
      });
    });
  }

  async function getCartVariantIds() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) return new Set();
    const cart = await safeParseResponseJson(res);
    const ids = new Set();
    if (cart && Array.isArray(cart.items)) {
      for (const item of cart.items) ids.add(item.id);
    }
    return ids;
  }

  async function autoAddMissingItems() {
    const items = getAutoAddItemsFromUI();
    if (!items.length) return;

    const existing = await getCartVariantIds();
    const toAdd = items.filter((it) => !existing.has(it.id));
    if (!toAdd.length) {
      log('Nothing to auto-add (already in cart).');
      return;
    }

    log('Auto-adding', toAdd);
    isAutoAdding = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: toAdd }),
        credentials: 'same-origin',
      });
      if (!res.ok) log('Auto-add failed', res.status);
    } finally {
      isAutoAdding = false;
    }
  }

  function scheduleAutoAddAfterMainAdd() {
    Promise.resolve()
      .then(() => autoAddMissingItems())
      .catch((err) => log('autoAddMissingItems failed', err));
  }

  function hookShopifyAddItem() {
    if (!window.Shopify || typeof Shopify.addItem !== 'function' || Shopify.addItem.__autoAdd2cartHooked) {
      return false;
    }
    const original = Shopify.addItem;
    Shopify.addItem = function (variantId, quantity, $target, callback, input) {
      const wrapped = function (lineItem) {
        scheduleAutoAddAfterMainAdd();
        if (typeof callback === 'function') callback(lineItem);
        else Shopify.onItemAdded(lineItem);
      };
      return original.call(this, variantId, quantity, $target, wrapped, input);
    };
    Shopify.addItem.__autoAdd2cartHooked = true;
    log('Hooked Shopify.addItem');
    return true;
  }

  if (!hookShopifyAddItem()) {
    document.addEventListener('DOMContentLoaded', () => {
      bindFreePartVariantPickers();
      if (hookShopifyAddItem()) return;
      let tries = 0;
      const timer = setInterval(() => {
        if (hookShopifyAddItem() || ++tries > 30) clearInterval(timer);
      }, 100);
    });
  }

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const res = await originalFetch(...args);
    try {
      if (isAutoAdding) return res;
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      const method = (args[1]?.method || 'GET').toUpperCase();
      if (method === 'POST' && typeof url === 'string' && url.includes('/cart/add')) {
        scheduleAutoAddAfterMainAdd();
      }
    } catch (e) {
      log('fetch hook error', e);
    }
    return res;
  };

  log('Initialized.');
  bindFreePartVariantPickers();
})();
